enum ConfiguratorActions {
    FETCH_IMAGES_LIST = "configuratorFetchImagesList",
    GET_IMAGE = "configuratorGetImage",
    UPDATE_IMAGE = "configuratorUpdateImage",
    DELETE_IMAGE = "configuratorDeleteImage",
    SYNC_IMAGES = "configuratorSyncImages",
    REFRESH_IMAGES_LIST = "configuratorRefreshImagesList",
    UPLOAD_IMAGES = "configuratorUploadImages",
    FETCH_BLACKLIST_LIST = "configuratorFetchBlacklistList",
    GET_BLACKLIST = "configuratorGetBlacklist",
    CREATE_BLACKLIST = "configuratorCreateBlacklist",
    UPDATE_BLACKLIST = "configuratorUpdateBlacklist",
    DELETE_BLACKLIST = "configuratorDeleteBlacklist",
    REFRESH_BLACKLIST_LIST = "configuratorRefreshBlacklistList",
    FETCH_SETTINGS_LIST = "configuratorFetchSettingsList",
    GET_SETTING = "configuratorGetSetting",
    CREATE_SETTING = "configuratorCreateSetting",
    UPDATE_SETTING = "configuratorUpdateSetting",
    DELETE_SETTING = "configuratorDeleteSetting",
    DUPLICATE_SETTING = "configuratorDuplicateSetting",
    EXPORT_SETTING = "configuratorExportSetting",
    IMPORT_SETTING = "configuratorImportSetting",
    REFRESH_SETTINGS_LIST = "configuratorRefreshSettingsList",

    // Sponsors
    FETCH_SPONSORS_LIST = "configuratorFetchSponsorsList",
    GET_SPONSOR = "configuratorGetSponsor",
    CREATE_SPONSOR = "configuratorCreateSponsor",
    UPDATE_SPONSOR = "configuratorUpdateSponsor",
    DELETE_SPONSOR = "configuratorDeleteSponsor",
    REFRESH_SPONSORS_LIST = "configuratorRefreshSponsorsList",

    // Options
    FETCH_OPTIONS_LIST = "configuratorFetchOptionsList",
    GET_OPTION = "configuratorGetOption",
    CREATE_OPTION = "configuratorCreateOption",
    UPDATE_OPTION = "configuratorUpdateOption",
    DELETE_OPTION = "configuratorDeleteOption",
    REFRESH_OPTIONS_LIST = "configuratorRefreshOptionsList",

    // Brands
    FETCH_BRANDS_LIST = "configuratorFetchBrandsList",
    GET_BRAND = "configuratorGetBrand",
    CREATE_BRAND = "configuratorCreateBrand",
    UPDATE_BRAND = "configuratorUpdateBrand",
    DELETE_BRAND = "configuratorDeleteBrand",
    REFRESH_BRANDS_LIST = "configuratorRefreshBrandsList",

    // Age Groups
    FETCH_AGE_GROUPS_LIST = "configuratorFetchAgeGroupsList",
    GET_AGE_GROUP = "configuratorGetAgeGroup",
    CREATE_AGE_GROUP = "configuratorCreateAgeGroup",
    UPDATE_AGE_GROUP = "configuratorUpdateAgeGroup",
    DELETE_AGE_GROUP = "configuratorDeleteAgeGroup",
    REFRESH_AGE_GROUPS_LIST = "configuratorRefreshAgeGroupsList",

    // Sport Filters
    FETCH_SPORT_FILTERS_LIST = "configuratorFetchSportFiltersList",
    GET_SPORT_FILTER = "configuratorGetSportFilter",
    CREATE_SPORT_FILTER = "configuratorCreateSportFilter",
    UPDATE_SPORT_FILTER = "configuratorUpdateSportFilter",
    DELETE_SPORT_FILTER = "configuratorDeleteSportFilter",
    REFRESH_SPORT_FILTERS_LIST = "configuratorRefreshSportFiltersList",

    // Delivery Countries
    FETCH_DELIVERY_COUNTRIES_LIST = "configuratorFetchDeliveryCountriesList",
    GET_DELIVERY_COUNTRY = "configuratorGetDeliveryCountry",
    CREATE_DELIVERY_COUNTRY = "configuratorCreateDeliveryCountry",
    UPDATE_DELIVERY_COUNTRY = "configuratorUpdateDeliveryCountry",
    DELETE_DELIVERY_COUNTRY = "configuratorDeleteDeliveryCountry",
    REFRESH_DELIVERY_COUNTRIES_LIST = "configuratorRefreshDeliveryCountriesList",

    // Products
    FETCH_PRODUCTS_LIST = "configuratorFetchProductsList",
    GET_PRODUCT = "configuratorGetProduct",
    CREATE_PRODUCT = "configuratorCreateProduct",
    UPDATE_PRODUCT = "configuratorUpdateProduct",
    DELETE_PRODUCT = "configuratorDeleteProduct",
    IMPORT_PRODUCTS = "configuratorImportProducts",
    FETCH_PRODUCTS_PICKER = "configuratorFetchProductsPicker",
    REFRESH_PRODUCTS_LIST = "configuratorRefreshProductsList",

    // Tracking
    FETCH_TRACKING_LIST = "configuratorFetchTrackingList",
    FETCH_TRACKING_DETAIL = "configuratorFetchTrackingDetail",
    REFRESH_TRACKING_LIST = "configuratorRefreshTrackingList",

    // Orders
    FETCH_ORDERS_LIST = "configuratorFetchOrdersList",
    GET_ORDER = "configuratorGetOrder",
    EXPORT_ORDER_CSV = "configuratorExportOrderCsv",
    EXPORT_ORDER_JSON = "configuratorExportOrderJson",
    UPDATE_ORDER = "configuratorUpdateOrder",
    REFRESH_ORDERS_LIST = "configuratorRefreshOrdersList",

    // Unlock Codes
    FETCH_UNLOCK_CODES_LIST = "configuratorFetchUnlockCodesList",
    GET_UNLOCK_CODE = "configuratorGetUnlockCode",
    CREATE_UNLOCK_CODE = "configuratorCreateUnlockCode",
    UPDATE_UNLOCK_CODE = "configuratorUpdateUnlockCode",
    DELETE_UNLOCK_CODE = "configuratorDeleteUnlockCode",
    IMPORT_UNLOCK_CODES = "configuratorImportUnlockCodes",
    REFRESH_UNLOCK_CODES_LIST = "configuratorRefreshUnlockCodesList",
}

enum ConfiguratorMutation {
    SET_RENDER_UPDATE = "configuratorListRenderNeeded",
    SET_IMAGES_LIST_RESULT = "configuratorImagesListResult",
    SET_BLACKLIST_LIST_RESULT = "configuratorBlacklistListResult",
    SET_SETTINGS_LIST_RESULT = "configuratorSettingsListResult",
    SET_SPONSORS_LIST_RESULT = "configuratorSponsorsListResult",
    SET_OPTIONS_LIST_RESULT = "configuratorOptionsListResult",
    SET_BRANDS_LIST_RESULT = "configuratorBrandsListResult",
    SET_AGE_GROUPS_LIST_RESULT = "configuratorAgeGroupsListResult",
    SET_SPORT_FILTERS_LIST_RESULT = "configuratorSportFiltersListResult",
    SET_DELIVERY_COUNTRIES_LIST_RESULT = "configuratorDeliveryCountriesListResult",
    SET_PRODUCTS_LIST_RESULT = "configuratorProductsListResult",
    SET_TRACKING_LIST_RESULT = "configuratorTrackingListResult",
    SET_ORDERS_LIST_RESULT = "configuratorOrdersListResult",
    SET_UNLOCK_CODES_LIST_RESULT = "configuratorUnlockCodesListResult",
}

export {ConfiguratorActions, ConfiguratorMutation};
